import React from 'react'
import Link from 'gatsby-link'

// const Header = () => (
//   <div className="Header">
//     <Link className="Header__logo" to="/">
//       おうちタイマー
//     </Link>
//   </div>
// )

const Header = () => (
  <div className="Header">
    <a className="Header__logo">
      おうちタイマー
    </a>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js